export enum PaymentMethods {
    STRIPE = 'Stripe',
    PROVET_PAY = 'ProvetPay',
}